module.exports = __webpack_public_path__ + "static/media/Page30.c37155a2.png";